import { useState, useEffect } from "react";
import { AnimatedText, AnimatedTitle } from "@/components/ui/AnimatedText";
import { apiFetch } from "@/utils/api";
import BookingForm from "@/components/forms/BookingForm";
import { useSEO } from "@/utils/useSEO";

export default function Book() {
  useSEO(
    "Book Your Stay",
    "Book your luxury villa at Patal Kikian Villas Sidemen, Bali. Choose from our Deluxe Bungalow, Suite Room, or Private Pool Villa and enjoy a breathtaking mountain retreat with Mount Agung views, spa, pool, and breakfast included."
  );
  const [villas, setVillas] = useState<any[]>([]);
  const [whatsappUrl, setWhatsappUrl] = useState("https://wa.me/6281353278504");

  useEffect(() => {
    let active = true;
    apiFetch('/accommodation').then(data => {
      if (active && Array.isArray(data)) {
        setVillas(data);
      }
    });

    apiFetch('/settings').then(data => {
      if (active && data) {
        const whatsapp = data.whatsapp || "6281234567890";
        const cleanWa = whatsapp.replace(/[^0-9]/g, '');
        setWhatsappUrl(`https://wa.me/${cleanWa}`);
      }
    });

    return () => {
      active = false;
    };
  }, []);

  return (
    <>
      <section className="pt-48 pb-12 bg-background">
        <div className="container mx-auto px-6 text-center">
          <AnimatedText delay={0.1} className="text-gold uppercase tracking-[0.3em] text-sm mb-4 font-semibold">
            Reservations
          </AnimatedText>
          <AnimatedTitle
            title="Book Your Stay"
            className="text-4xl md:text-6xl text-white mb-6 max-w-4xl mx-auto"
          />
        </div>
      </section>

      <section className="pb-32 bg-background">
        <div className="container mx-auto px-6 max-w-3xl">
          <AnimatedText delay={0.2} className="bg-secondary p-8 md:p-12 rounded-2xl border border-white/5 shadow-2xl">
            <BookingForm villas={villas} whatsappUrl={whatsappUrl} />
          </AnimatedText>
        </div>
      </section>
    </>
  );
}
